export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="absolute top-0 right-0 w-[500px] h-[500px] md:w-[700px] md:h-[700px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] md:w-[550px] md:h-[550px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line"></i>
              实时更新 · 全网追踪
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 leading-tight mb-4">
              51黑料吃瓜网
              <span className="block text-primary-500 mt-1">
                全网最全黑料吃瓜第一站
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-medium mb-4">
              海量黑料，高清流畅，随时随地免费看
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51黑料吃瓜网汇聚全网最新最热的娱乐八卦、网红黑料、社会热点事件，覆盖吃瓜在线视频、黑料在线播放等海量内容。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              每日持续更新，无需下载安装，打开浏览器即可高清流畅观看。无论是51吃瓜在线观看还是51黑料在线观看，这里都是你最值得收藏的吃瓜第一站。当前热门话题涵盖娱乐圈最新动态、网红争议事件追踪、热门综艺独家爆料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">10W+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">每日活跃吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">5000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">黑料视频资源库</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-600">24h</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">全天候实时更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-medium text-sm md:text-base hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机端体验
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-400/20 via-accent-400/15 to-secondary-400/20 rounded-3xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20illustration%20representing%20social%20media%20gossip%20and%20entertainment%20news%2C%20warm%20orange%20and%20pink%20gradient%20background%2C%20floating%20speech%20bubbles%20and%20news%20icons%2C%20dynamic%20wave%20patterns%2C%20modern%20flat%20design%20style%2C%20playful%20and%20energetic%20atmosphere%2C%20digital%20art%20aesthetic%2C%20clean%20composition%20with%20negative%20space&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="51黑料吃瓜网 - 全网热门黑料吃瓜平台主视觉"
                className="relative w-full h-auto rounded-3xl object-cover"
                width="800"
                height="600"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}